import { render, staticRenderFns } from "./claim-reporting.vue?vue&type=template&id=19db5167&"
import script from "./claim-reporting.vue?vue&type=script&lang=js&"
export * from "./claim-reporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports